import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './MainOptions.module.css';

const comercialBg = process.env.PUBLIC_URL + '/comercial.jpg';
const residencialBg = process.env.PUBLIC_URL + '/residencial.jpg';

const MainOptions = () => {
  const navigate = useNavigate();

  const handleClick = (tipo) => {
    if (tipo === 'comercial') {
      navigate('/imoveis?tipo_operacao=venda&q=comercial');
      return;
    }

    navigate('/imoveis?tipo_operacao=locacao');
  };

  return (
    <main className={styles['main-options']}>
      <section className={styles.heroConteudo}>
        <p className={styles.kicker}>Imobiliaria Cardano</p>
        <h1>Encontre, anuncie e negocie com seguranca.</h1>
        <p className={styles.subtitulo}>
          Um portal simples para quem busca imovel e para clientes que querem anunciar.
        </p>
        <div className={styles.heroAcoes}>
          <button className="ui-button-primary" onClick={() => navigate('/imoveis?tipo_operacao=venda')} type="button">Quero comprar</button>
          <button className="ui-button-primary" onClick={() => navigate('/imoveis?tipo_operacao=locacao')} type="button">Quero alugar</button>
        </div>
      </section>

      <div className={styles['options-container']}>
        <div
          className={`${styles['option']} ${styles['comercial']}`}
          style={{ backgroundImage: `linear-gradient(rgba(239,22,22,0.4), rgba(239,22,22,0.4)), url(${comercialBg})` }}
          onClick={() => handleClick('comercial')}
        >
          <span className={styles['option-label']}>Comercial e Industrial</span>
          <span className={styles['option-description']}>Galpoes, salas, lojas e espacos corporativos.</span>
        </div>
        <div
          className={`${styles['option']} ${styles['residencial']}`}
          style={{ backgroundImage: `linear-gradient(rgba(235, 215, 215, 0.8), rgba(235, 215, 215, 0.7)), url(${residencialBg})` }}
          onClick={() => handleClick('residencial')}
        >
          <span className={styles['option-label']}>Residencial</span>
          <span className={styles['option-description']}>Casas e apartamentos com filtros claros e rapidos.</span>
        </div>
      </div>
    </main>
  );
};

export default MainOptions; 